import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {Address, getMapUrl} from '../locations.types'

@Component({
  selector: 'cft-map-address',
  templateUrl: './map-address.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      @reference '../../../../styles/theme.css';

      :host {
        @apply relative block;
      }
    `,
  ],
  standalone: false,
})
export class MapAddressComponent {
  @Input() address!: Address
  @Input() rounded: 'none' | 'full' | 'top' = 'none'
  @Input() defaultLocationLabel?: string
  @Input() showMap = true
  @Input() gMapsApiKey!: string
  @Input() zoom = 10

  get url(): string {
    return getMapUrl(this.address, this.zoom, this.gMapsApiKey)
  }
}
